/**
 * validation.js
 */

export const messages = {
    address: { required: "O campo endereço é obrigatório" },
    area_expertise: { required: "O campo área de atuação é obrigatório" },
    area_interest: { required: "Por favor, informe que área você tem interesse" },
    city: { required: "O campo cidade é obrigatório" },
    company_city: { required: "O campo cidade é obrigatório" },
    company_state: { required: "O campo estado é obrigatório" },
    cpf: { required: "O campo CPF é obrigatório", },
    email: {
        required: "O campo e-mail é obrigatório",
        email: "O e-mail informado não é válido",
    },
    level_student: { required: "O campo nível educacional é obrigatório" },
    message: { required: "Por favor, escreva uma mensagem" },
    mobile_phone: { required: "O campo celular é obrigatório" },
    name: { required: "O campo nome é obrigatório" },
    operating_city: { required: "Você deve informar em qual cidade deseja atuar" },
    operating_state: { required: "Você deve informar em qual estado deseja atuar" },
    phone: { required: "O campo telefone é obrigatório" },
    question: { required: "O campo pergunta é obrigatório" },
    state: { required: "O campo estado é obrigatório" },
}